import React, { useEffect, useState } from "react";
import {
  Box,
  Breadcrumbs,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import {
  getApiCall,
  getuserprofile,
  postApiCall,
  updateProfile,
} from "../../API/baseUrl";
import ToastMessage from "../../utils/ToastMessage";
import { ThreeDots } from "react-loader-spinner";
import { profileSchema } from "../../utils/validation";
import ButtonForAll from "../../components/ButtonForALL";
import "./index.css";
import { BreadcrumbsFunction } from "../../Componentsnew/Breadcrumbs/Index";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
const Profile = () => {
  const user_id = localStorage.getItem("user_id");
  const mobile = localStorage.getItem("mobile");
  const [value, setValue] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [mobilevalue, setMobilevalue] = React.useState(mobile);
  const [showerror, setshowerror] = useState(false);
  const handleradioChange = (event) => {
    setValue(event.target.value);
  };
  console.log(showerror, "showerrorshowerror");

  const initialValues = {
    firstname: "",
    lastname: "",
    mobile: mobilevalue,
    email: "",
    dial_code: "",
  };

  // Define submitForm function
  const submitForm = async () => {
    const apiValue = {
      mobile: values.mobile,
      dial_code: values.dial_code,
      first_name: values.firstname,
      last_name: values.lastname,
      email: values.email,
      gender: value,
    };
    setLoading(true);
    try {
      const result = await postApiCall(`${updateProfile}/${user_id}`, apiValue);
      if (result.data.status) {
        ToastMessage("success", result.data.message);
        localStorage.setItem("name", values.firstname);
        getProfile();
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // useFormik hook
  const {
    isSubmitting,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues,
    validationSchema: profileSchema,
    onSubmit: submitForm, // Reference submitForm here
  });
  console.log(isSubmitting, "isSubmitting");
  useEffect(() => {
    if (isSubmitting) {
      setshowerror(true);
    }
  });
  const getProfile = async () => {
    try {
      const result = await getApiCall(`${getuserprofile}/${user_id}`);
      if (result?.data?.status) {
        const { dial_code, mobile, first_name, last_name, email, gender } =
          result?.data?.data || {};
        setValue(gender);
        setMobilevalue(mobile);
        handleChange({ target: { name: "gender", value: gender } });
        handleChange({ target: { name: "firstname", value: first_name } });
        handleChange({ target: { name: "lastname", value: last_name } });
        handleChange({ target: { name: "email", value: email } });
        handleChange({ target: { name: "dial_code", value: dial_code } });
      } else {
        // Handle error state or no data scenario
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <div className="profile-page-container">
      <div className="background-image"></div>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 600,
          margin: "auto",
          backgroundColor: "white",
          borderRadius: 3,
          p: 4,
          boxShadow: 3,
          // mt: 1,
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ mb: 3 }}
        >
          <BreadcrumbsFunction link1="Home" page="profile" />
        </Breadcrumbs>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="First Name"
              name="firstname"
              value={values.firstname}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(errors.firstname && touched.firstname)}
              helperText={touched.firstname && errors.firstname}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Last Name"
              name="lastname"
              value={values.lastname}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(errors.lastname && touched.lastname)}
              helperText={touched.lastname && errors.lastname}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(errors.email && touched.email)}
              helperText={touched.email && errors.email}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Mobile"
              name="mobile"
              value={values.mobile}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled
              focused
              error={Boolean(errors.mobile && touched.mobile)}
              helperText={touched.mobile && errors.mobile}
            />
          </Grid>

          <Grid item xs={12}>
            <FormLabel sx={{ fontWeight: 600, mb: 1 }}>
              <Typography variant="body1">Your Gender</Typography>
            </FormLabel>
            <RadioGroup
              row
              name="gender"
              value={values?.gender}
              onChange={(e) => setFieldValue("gender", e.target.value)}
            >
              <FormControlLabel
                value="male"
                control={<Radio sx={{ color: "var(--primary-color)" }} />}
                label={<Typography variant="body2">Male</Typography>}
              />
              <FormControlLabel
                value="female"
                control={<Radio sx={{ color: "var(--primary-color)" }} />}
                label={<Typography variant="body2">Female</Typography>}
              />
            </RadioGroup>
            {showerror && (
              <FormHelperText
                sx={{ color: "#d32f2f", marginLeft: "14px", fontWeight: 500 }}
              >
                {errors.gender}
              </FormHelperText>
            )}
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              width: "100vw",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ButtonForAll
              name={loading ? "Loading" : "Save"}
              type="submit"
              disabled={loading}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Profile;
